class Report {

  constructor() {
  }

  init() {
    this.$page = document.querySelector('#reports_index');

    if (!this.$page) return;

    this.$colLeft = this.$page.querySelector('.column-left');

    this.fixEmptyLeftCol();
  }

  setupEvents() {
  }

  /**
   * Removes left column of reports if it is empty.
   *
   * This can be done on view, but it requires making a list of permissions of left column reports,
   * which is not convenient for application support and also it requires double-checking of those
   * permissions before generating left column, which may be expensive operation.
   */
  fixEmptyLeftCol() {

    if (this.$colLeft.childNodes.length === 0) {
      this.$colLeft.remove();
    }
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new Report();
